import React, { useState } from "react";

// Brutalist confirmation modal requiring the user to type "DELETE" before the destructive action.
export default function ConfirmDeleteModal({
  open,
  title,
  subjectLabel,
  subjectName,
  warning,
  requiredWord = "DELETE",
  confirmLabel = "Delete permanently",
  onCancel,
  onConfirm,
  busy = false,
}) {
  const [typed, setTyped] = useState("");
  if (!open) return null;
  const matches = typed.trim().toUpperCase() === requiredWord.toUpperCase();

  const reset = () => setTyped("");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" data-testid="delete-modal">
      <div className="cal-card cal-shadow max-w-md w-full p-8 bg-white">
        <div className="font-mono-cal text-[10px] uppercase tracking-widest text-[#FF4F00] mb-2">[ DANGER ZONE ]</div>
        <h2 className="font-display font-bold text-3xl mb-3">{title}</h2>
        {(subjectLabel || subjectName) && (
          <p className="text-[#666] mb-2">
            {subjectLabel} <span className="font-medium text-[#111]">"{subjectName}"</span>
          </p>
        )}
        {warning && <p className="text-[#666] mb-5 text-sm">{warning}</p>}

        <div className="mb-5">
          <label className="cal-label">Type <span className="font-bold text-[#111]">{requiredWord}</span> to confirm</label>
          <input
            autoFocus
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            placeholder={requiredWord}
            className="cal-input font-mono-cal"
            data-testid="delete-confirm-input"
          />
        </div>

        <div className="flex gap-3 justify-end">
          <button onClick={() => { reset(); onCancel(); }} disabled={busy} className="cal-btn cal-btn-ghost" data-testid="delete-cancel">
            Cancel
          </button>
          <button
            onClick={() => { if (matches) onConfirm(); }}
            disabled={!matches || busy}
            className="cal-btn"
            style={matches ? { background: "#B00020" } : undefined}
            data-testid="delete-confirm"
          >
            {busy ? "Deleting…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
